import { createFileRoute, notFound, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/$")({
  loader: async ({ params }) => {
    if (params._splat) {
      if (["cookie-notice", "cookie-policy"].includes(params._splat)) {
        throw redirect({ href: "https://trove.works/cookie-notice" });
      } else if (["privacy-notice", "terms-and-conditions"].includes(params._splat)) {
        throw redirect({ href: `https://trove.works/${params._splat}` });
      }
    }
    throw notFound();
  },
});
